import { MasterItem } from './master-model';
import { BaseModel } from './../../home/share/interface/base';
export interface UnileverUserInfo {
  id: string;
  uid: string;
  fullName: string;
  username: string;
  authToken: string;
  refreshToken: string;
  transactionCode: string;
  campaignId: number;
  maxGiftPerUser: number;
  role: string;
  mall: MasterItem;
  store: MasterItem;
  userTypeId: number;
  userTypeName: string;
  qrLoginEnable: boolean;
  physScannerEnable: boolean;
  storeControlEnable: boolean;
  physCampaignId: number;
  skipPIIEnable: boolean;
}

  export class LogoutRequest{
    transactionCode: string;
  }
  export class QrInfoUser{
    qrLink: string;
  }

  export class RefreshRequest{
    accessToken: string;
    refreshToken: string;
  }

  export class RefreshResponse{
    token: string;
  }